import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

import { getErrorCountKey } from '@/configuration/helpers/helpers'

const RefundMethodErrorsChip = ({ count }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Chip
      label={t(getErrorCountKey(count), { count })}
      Icon={WarningIcon}
      backgroundColor={theme.colors.danger.surface}
      color={theme.colors.danger.onSurface}
    />
  )
}

export default RefundMethodErrorsChip
